import React from 'react';
import { FlexGrid as Grid, Row, Column } from '@carbon/react';
import { Section } from 'components/section';
import { Field } from 'components/field';
import { Date } from 'components/date';
import { TypeCurveHeader } from 'types/api-responses';
import { format0 } from 'utils/number';
import style from './type-curve-details-section.module.scss';

interface TypeCurveDetailsSectionProps {
  typeCurveData: TypeCurveHeader;
}

export const TypeCurveDetailsSection: React.FC<
  TypeCurveDetailsSectionProps
> = ({ typeCurveData }) => {
  return (
    <div className={style.detailsSection}>
      <Section header="Type Curve Details">
        <Grid className="bx--no-gutter" fullWidth>
          <Row className={style.detailsRow}>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field label="Basin" value={typeCurveData.basin || '--'} />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field label="Status" value={typeCurveData.status || '--'} />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Lateral Length"
                  value={
                    typeCurveData.lateralLengthFt
                      ? `${format0(typeCurveData.lateralLengthFt)} ft`
                      : '--'
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Date Created"
                  value={
                    typeCurveData.createdAt ? (
                      <Date date={typeCurveData.createdAt} format="M/DD/YYYY" />
                    ) : (
                      '--'
                    )
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Created By"
                  value={typeCurveData.createdBy || '--'}
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Created At"
                  value={
                    typeCurveData.createdAt ? (
                      <Date
                        date={typeCurveData.createdAt}
                        format="M/DD/YYYY h:mm A"
                        showTime
                      />
                    ) : (
                      '--'
                    )
                  }
                />
              </div>
            </Column>
          </Row>

          <Row className={style.detailsRow}>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Type Curve Area"
                  value={typeCurveData.typeCurveAreaName || '--'}
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Type Curve Formation"
                  value={typeCurveData.formation || '--'}
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Well Count"
                  value={
                    typeCurveData.wellCount !== null
                      ? format0(typeCurveData.wellCount)
                      : '--'
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Updated At"
                  value={
                    typeCurveData.updatedAt ? (
                      <Date
                        date={typeCurveData.updatedAt}
                        format="M/DD/YYYY h:mm A"
                        showTime
                      />
                    ) : (
                      '--'
                    )
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Last Verification Date"
                  value={
                    typeCurveData.effectiveVerification?.lastVerifiedDate ? (
                      <Date
                        date={
                          typeCurveData.effectiveVerification?.lastVerifiedDate
                        }
                        format="M/DD/YYYY h:mm A"
                        showTime
                      />
                    ) : (
                      '--'
                    )
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Last Verified By"
                  value={
                    typeCurveData.effectiveVerification?.lastVerifiedBy || '--'
                  }
                />
              </div>
            </Column>
          </Row>

          <Row className={style.detailsRow}>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Proppant Intensity (lbs/ft)"
                  value={
                    typeCurveData.proppantIntensityLbsFt !== null
                      ? `${format0(
                          typeCurveData.proppantIntensityLbsFt
                        )} lbs/ft`
                      : '--'
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Fluid Intensity (gal/ft)"
                  value={
                    typeCurveData.fluidIntensityGalFt !== null
                      ? `${format0(typeCurveData.fluidIntensityGalFt)} gal/ft`
                      : '--'
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2}>
              <div className={style.typeCurveDetails}>
                <Field
                  label="Fluid Intensity (bbl/ft)"
                  value={
                    typeCurveData.fluidIntensityBblFt !== null
                      ? `${format0(typeCurveData.fluidIntensityBblFt)} bbl/ft`
                      : '--'
                  }
                />
              </div>
            </Column>
            <Column md={12} lg={2} />
            <Column md={12} lg={2} />
            <Column md={12} lg={2} />
          </Row>
        </Grid>
      </Section>
    </div>
  );
};
